import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { parse } from 'query-string';
import moment from 'moment-timezone';
import getQueryUtils, { attributeKeys } from './queryUtils';

export default function useEducatorSupportQuestions(props) {
  const {
    search = {},
    pageSize = 10
  } = props;

  const [timestamp] = useState(moment().toISOString());

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  return useConnect('supportQuestion.find', {
    where: {
      eager: {
        $where: {
          $and: [...queryUtils.where],
          audience: 'Educator'
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'order asc'
    }
  }, {
    keepPreviousData : true
  });
}
